import '@fontsource/raleway/500.css'; // Weight 500
import '@fontsource/raleway';
import '@fontsource/poppins';

export const onInitialClientRender = () => {
    setTimeout(function () {
        document.getElementById('___loader').style.display = 'none';
    }, 2000);
};
